// extracted by mini-css-extract-plugin
export default {"inputBox":"n_RgkelVZjiag_M8rPEA","paymentDetailsBox":"Val8hOYQAzXF6uLHZyRY"};